import { Typography } from 'antd';
import React from 'react';

import { MObywatelRequest } from './types';

const { Text } = Typography;

interface AdminSafetyIndicatorProps {
  requests: MObywatelRequest[];
}

export const AdminSafetyIndicator: React.FC<AdminSafetyIndicatorProps> = ({ requests }) => {
  const activeRequests = requests.filter((r) =>
    ['instructions_shown', 'waiting_for_code', 'code_provided', 'awaiting_user_response', 'user_inactive'].includes(
      r.status
    )
  );

  const canLeave = activeRequests.length === 0;

  return (
    <div
      className={`mb-4 p-3 rounded-lg border ${
        canLeave ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
      }`}>
      <div className="flex items-center space-x-2">
        <span className="text-lg">{canLeave ? '✅' : '❌'}</span>
        <Text strong className={canLeave ? 'text-green-700' : 'text-red-700'}>
          {canLeave ? 'Możesz bezpiecznie opuścić panel' : 'NIE opuszczaj panelu - weryfikacje w toku'}
        </Text>
      </div>
      {!canLeave && (
        <Text type="secondary" className="text-xs block mt-1">
          Aktywne weryfikacje: {activeRequests.length} | Poczekaj na zakończenie wszystkich procesów
        </Text>
      )}
    </div>
  );
};
